<app-window-title [id]="data?.id"
                  [message]="data?.message"
                  [title]="data?.title"></app-window-title>
<div  class="fx-col fx-gap-10">
  <p>
    Please select a category for the files you are going to upload.
  </p>
  <mat-form-field color="warn"
                  appearance="outline">
    <mat-label>
      Choose Category
    </mat-label>
    <mat-select *ngIf="categories?.length > 0; else noCategories"
                [(ngModel)]="selectedCategory"
                (selectionChange)="handleSelectionChange()">
      <ng-container *ngFor="let category of categories">
        <mat-option [disabled]="category.subcategories?.length > 0"
                    [value]="category">
          {{ category.name }}
        </mat-option>
        <ng-container *ngIf="category.subcategories?.length > 0">
          <ng-container *ngFor="let subCategory of category.subcategories">
            <mat-option class="sub-category-option"
                        [value]="subCategory">
              &nbsp;&nbsp;&nbsp;{{ subCategory.name }}
            </mat-option>
          </ng-container>
        </ng-container>
      </ng-container>
    </mat-select>
    <ng-template #noCategories>
      <mat-option value>
        No categories found
      </mat-option>
    </ng-template>
  </mat-form-field>
</div>
